import { createReducer } from "redux-act";
import createAction from "../utils/createMetaAction";
export const sequenceNameUpdate = createAction("sequenceNameUpdate");
export default createReducer(
  {
    [sequenceNameUpdate]: (state, payload) => {
      return payload;
    }
  },
  "Untitled Sequence"
);
